import { CustomizationStep } from './types';

export const STEP_CONFIG: Record<
  CustomizationStep,
  { number: number; label: string }
> = {
  [CustomizationStep.PREFERENCES]: {
    number: 1,
    label: 'course.customization.steps.preferences',
  },
  [CustomizationStep.PROCESSING]: {
    number: 2,
    label: 'course.customization.steps.processing',
  },
  [CustomizationStep.REVIEW]: {
    number: 3,
    label: 'course.customization.steps.review',
  },
  [CustomizationStep.PREVIEW]: {
    number: 4,
    label: 'course.customization.steps.preview',
  },
  [CustomizationStep.TRANSLATION]: {
    number: 5,
    label: 'course.customization.steps.translation',
  },
  [CustomizationStep.COMPLETE]: {
    number: 6,
    label: 'course.customization.steps.complete',
  },
};

export const STEP_ORDER: CustomizationStep[] = [
  CustomizationStep.PREFERENCES,
  CustomizationStep.PROCESSING,
  CustomizationStep.REVIEW,
  CustomizationStep.PREVIEW,
  CustomizationStep.TRANSLATION,
];
